import { DATE_FORMAT } from '@ui-framework/index';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import TimeSlotTypeChip from '../components/TimeSlotTypeChip';

function formatDateTime({
  date,
  after = null,
  before = null,
  slotCode = null,
  slotTypes,
}) {
  if (!date) return '';
  const dated = dayjs(date).format(DATE_FORMAT.MEDIUM_DATE);

  if (slotCode) {
    const slotFound = slotTypes?.find(i => i.code === slotCode);
    return (
      <Box>
        {dated}{' '}
        <TimeSlotTypeChip
          sx={{ ml: 1 }}
          name={slotFound?.name}
          code={slotFound?.code}
        />
      </Box>
    );
  }

  const afterHour = after ? dayjs(after, 'HH:mm').format('hh:mm A') : '';
  const beforeHour = before ? dayjs(before, 'HH:mm').format('hh:mm A') : '';
  if (afterHour && beforeHour) {
    return `${dated} between ${afterHour} - ${beforeHour}`;
  }
  if (afterHour) {
    return `${dated} after ${afterHour}`;
  }
  if (beforeHour) {
    return `${dated} before ${beforeHour}`;
  }
  return dated;
}

export default formatDateTime;
